/**
 * Formateadores compartidos de números y porcentajes.
 *
 * OJO con la escala: el backend Raptor entrega `humanRate` y `voicemailRate`
 * como **fracción 0..1** (`human / (human + voicemail)`), tanto en el tick del
 * WS (`MetricsWindow`) como en `GET /v1/reports/{dashboard,summary}` — el
 * Swagger lo dice explícito: "0..1". Pintar esa fracción con un formateador
 * que solo agrega " %" mostraba 0.5 % donde el valor real era 50.9 %.
 *
 *   - `pct(v)`      → v YA viene en 0..100 (porcentaje calculado en el front).
 *   - `pctRate(v)`  → v viene en 0..1 (una tasa del backend).
 */

/** Formatea un porcentaje que ya viene en escala 0..100. */
export const pct = (v: number | undefined | null, decimals = 1): string =>
  v === undefined || v === null || Number.isNaN(Number(v))
    ? '—'
    : `${Number(v).toFixed(decimals)} %`;

/** Formatea una tasa del backend (fracción 0..1) como porcentaje. */
export const pctRate = (v: number | undefined | null, decimals = 1): string =>
  v === undefined || v === null || Number.isNaN(Number(v))
    ? '—'
    : `${(Number(v) * 100).toFixed(decimals)} %`;

/** Entero con separadores de miles en es-MX. */
export const num = (v: number | undefined | null): string =>
  v === undefined || v === null || Number.isNaN(Number(v))
    ? '—'
    : Number(v).toLocaleString('es-MX');
